import { render, staticRenderFns } from "./Sanciones.vue?vue&type=template&id=90d267ea"
import script from "./Sanciones.vue?vue&type=script&lang=js"
export * from "./Sanciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports